import React, { Fragment, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import DeviceFrame from "../../views/device/DeviceFrameView";
import { Request } from "../../api/connections/Connection.api";

const DeviceContainer = ({ item, date, onCloseDevice = () => {} }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState(null);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    setLoading(true);
    Request.openConnection({
      token: token.access,
      id: item.id,
    })
      .then((data) => onSuccessOpenConnection(data))
      .catch((error) => onFailureOpenConnection(error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const onSuccessOpenConnection = ({ data }) => {
    setLoading(false);
    setUrl(data.data.data);
  };

  const onFailureOpenConnection = (error) => {
    setError(error);
    setLoading(false);
  };

  const handleClose = () => {
    setLoading(true);
    Request.closeConnection({
      token: token.access,
      id: item.id,
    })
      .then(() => {
        setLoading(false);
        setUrl(null);
        onCloseDevice();
      })
      .catch(() => {
        setLoading(false);
        setUrl(null);
        onCloseDevice();
      });
  };

  return (
    <Fragment>
      {error ? <Error message={error.message} /> : null}
      <DeviceFrame
        item={item}
        url={url}
        handleClose={handleClose}
        loading={loading}
        date={date}
      />
    </Fragment>
  );
};

export default DeviceContainer;
